import React from "react";
import { Grid } from "semantic-ui-react";

import { Route, Switch } from "react-router-dom";

import LoginForm from "../components/login/LoginForm";
import SignupForm from "../components/login/SignupForm";

export default () => {
  return (
    <div className="login-form">
      {/*
        Heads up! The styles below are necessary for the correct render of this example.
        You can do same with CSS, the main idea is that all the elements up to the `Grid`
        below must have a height of 100%.
      */}
      <style>{`
        body > div,
        body > div > div,
        body > div > div > div.login-form {
          height: 100%;
          background: #4267bb !important; /* Old browsers */
          background: -moz-linear-gradient(45deg, #4267bb 0%, #17357a 100%) !important; /* FF3.6-15 */
          background: -webkit-linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* Chrome10-25,Safari5.1-6 */
          background: linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
          filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4267bb', endColorstr='#17357a',GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
        }
      `}</style>
      <Grid
        textAlign="center"
        style={{ height: "100%" }}
        verticalAlign="middle"
      >
        <Switch>
          <Route exact path="/signup" component={SignupForm} />
          <Route path="/" component={LoginForm} />
        </Switch>
      </Grid>
    </div>
  );
};



// WEBPACK FOOTER //
// ./frontend/src/views/LoginView.js